// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2RwwM","requiredAsterisk":"Info_requiredAsterisk__2773J"};